/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React, { useState, useEffect, Fragment, useRef } from 'react';
import {
    Persona, PersonaSize, PrimaryButton, DefaultButton, SearchBox, DetailsList, NormalPeoplePicker, CheckboxVisibility, Checkbox, Spinner, SpinnerSize
} from '@fluentui/react';
import _ from "lodash"
import { shallowEqual, useSelector } from 'react-redux';

const btn = css`
    .ms-Button.is-checked{
       background-color: var(--themePrimary2);
        border: none;
        color: #fff;
    }
`;
const container = css`
    .ms-DetailsRow-fields{
       flex: 1;
    }
`;
const volume0Icon = {};
const volume3Icon = { iconName: 'CheckMark' };

function PeopleSelectWithGroups(props) {
    const [toList, setToList] = React.useState([]);
    const [items, setItems] = React.useState([]);
    const [filterText, setFilter] = React.useState('');
    const [selectedGroups, setSelectedGroups] = React.useState([]);
    const [selectedUsers, setSelectedUsers] = React.useState([]);

    const columns = [
        {
            key: 'more',
            name: '',
            fieldName: 'userId',
            onRender: (item) => {
                return buildRow(item)
            }
        },
    ];

    const buildRow = (item) => {
        return <div className="displayflex flex1 aligncenter" style={{ justifyContent: 'space-between' }}>
            <div className="displayflex flex1" onClick={() => onItemChange(item)}>
                <Persona
                    key={item.userId}
                    imageUrl={item.imageUrl}
                    imageInitials={item.imageInitials}
                    text={item.text}
                    initialsColor={item.initialsColor}
                    size={PersonaSize.size24}
                />
            </div>
            <div>
                <Checkbox checked={item.checked} onChange={() => onItemChange(item)} />
            </div>
        </div>
    }
    const { facilityId, roles, employees } = useSelector(state => ({
        facilityId: state.appState.product.facility.facilityID,
        roles: state.appState.product.facility.facilityRoles,
        employees: state.appState.product.facility.employees.filter(x => x.active)
    }));

    useEffect(() => {

        var avatarColors = ["#05C7F2", "#F27F1B", "#00c985", "#0583F2", "#0084ff"];
        var i = 0;
        var items = [{
            roleId: "EntireTeam",
            key: facilityId,
            imageInitials: "ET",
            initialsColor: "#05C7F2",
            text: "Entire team",
            type: 'team'
        }];

        roles.forEach((element, index) => {
            const item = {
                roleId: element.roleId,
                key: element.roleId,
                imageInitials: element.name.substring(0, 1),
                initialsColor: avatarColors[i],
                imageUrl: process.env.REACT_APP_CDN_URL + element.profileImage,
                text: element.name,
                type: 'role'
            };
            items.push(item);
            if (i == 4) {
                i = 0;
            } else {
                i++
            }
        });

        employees.forEach((element, index) => {
            if (element.firstName == "FacilityDeleteTest" || element.firstName == "Rachel") {
                
            }
            const item = {
                role: element.role,
                checked: false,
                userId: element.userId,
                roleId: element.roleId ? element.roleId.toString() : "",
                key: element.userId.toString(),
                imageUrl: element.profileImage ? process.env.REACT_APP_CDN_URL + element.profileImage : null,
                imageInitials: element.firstName.substring(0, 1) + element.lastName.substring(0, 1),
                initialsColor: element.avatarColor,
                text: element.firstName + ' ' + element.lastName,
                type: 'employee'
            };
            items.push(item);
        });

        if (props.selected) {
            items.forEach(x => {
                if (props.selected.indexOf(x.userId) > -1) {
                    x.checked = true;
                }
            })
        }

        setItems(_.sortBy(items, "role"))

    }, []);

    useEffect(() => {
        props.callback(items.filter(x => x.type === 'employee' && x.checked))
    }, [items]);



   


    const onItemChange = (item) => {

        var tlist = toList;
        var masterList = items;
        //if type = all - add all
        //if type = role add all users in that role
        //if 
        let index = masterList.findIndex(x => x.key == item.key);
        //let selectedList = [];

        if (item.checked) {
            masterList[index].checked = false;
            if (item.type === 'employee') {
                //selectedList = tlist.filter(x => x.key != item.key);
            } else if (item.type === 'team') {
                //selectedList = [];
                masterList.forEach((element, index) => {
                    //if (element.type == 'employee') {
                        element.checked = false;
                    //}
                });
            } else {
                masterList.forEach((element, index) => {
                    if (element.roleId == item.roleId && element.type == 'employee') {
                        element.checked = false;
                    }
                });
                //selectedList = tlist.filter(x => x.roleId == item.roleId);
            }
        } else {
            masterList[index].checked = true;
            if (item.type === 'employee') {
               // tlist.push(item);
               // selectedList = tlist;
            } else if (item.type === 'team') {
               // selectedList = masterList.filter(x => x.type == 'employee');
                masterList.forEach((element, index) => {
                    if (element.type == 'employee') {
                        element.checked = true;
                    }
                });
            } else {
                masterList.forEach((element, index) => {
                    if (element.roleId == item.roleId && element.type == 'employee') {
                        element.checked = true;
                       // selectedList.push(element)
                    }
                });
            }
            
        }

        let ml = [...masterList];
        //let sl = [...selectedList];

       // setToList(sl)
        setItems(ml)

    };

    const groupsGenerator = (itemsList, fieldName) => {
        itemsList = _.sortBy(itemsList, "role");

        if (fieldName == 'ungroup') {
            return null;
        }
        if (!itemsList) {
            return []
        }
        // Array of group objects
        const groupObjArr = []

        // Get the group names from the items list
        const groupNames = [...new Set(itemsList.map(item => item[fieldName]))]

        // Iterate through each group name to build proper group object
        groupNames.forEach(gn => {
            // Count group items
            const groupLength = itemsList.filter(item => item[fieldName] === gn).length

            // Find the first group index
            const groupIndex = itemsList.map(item => item[fieldName]).indexOf(gn)

            // Generate a group object
            groupObjArr.push({
                key: gn, name: gn, level: 0, count: groupLength, startIndex: groupIndex
            })
        })
        return groupObjArr
    }

    return (
        <div className="chat-list width100" css={container }>

            <div className="displayflex flexcolumn width100 border-bottom" css={btn} style={{ padding: '15px 0px 10px' }} >
                <h5 className="head-xs" style={{ fontSize: 13 }} >Select a group</h5>
                <div className="mb15 displayflex border-bottom pt10 pb5 custom-scrollbar" style={{ overflowY: 'hidden !important' }}>

                    {items.filter(x => x.type != "employee").map((r) => {
                        return <DefaultButton
                            text={r.text}
                            className="btn-secondary-white"
                            iconProps={r.checked ? volume3Icon : volume0Icon}
                            checked={r.checked}
                            onClick={() => onItemChange(r)}
                        />
                    })}
                </div>
                <div className="displayflex spacebetween">
                    <h5 className="head-xs mb10" style={{ fontSize: 13 }} >Employees selected </h5>
                    <h5 className="head-xs mb10" style={{ fontSize: 13 }} >{items.filter(x => x.type == "employee" && x.checked).length}</h5>
                </div>
                <SearchBox placeholder="Filter" style={{ root: { width: 300 } }} className="" onChange={(_, newValue) => setFilter(newValue)} />
            </div>
            <div className="custom-scrollbar height100 employee-picker" style={{ height: props.height ? props.height : 'calc(100vh - 310px)', maxHeight: props.maxHeight ? props.maxHeight : '100%' }}>
                {items.length > 0 &&
                    <DetailsList
                        selectionPreservedOnEmptyClick={false}
                        items={items.filter(x => x.type == "employee").filter(x => (x.text.toLowerCase().indexOf(filterText.toLowerCase()) !== -1) || !filterText)}
                        checkboxVisibility={CheckboxVisibility.hidden}
                        groups={groupsGenerator(items.filter(x => x.type == "employee").filter(x => (x.text.toLowerCase().indexOf(filterText.toLowerCase()) !== -1) || !filterText), "role")}
                        columns={columns}
                        isHeaderVisible={false}
                    />
                }

            </div>

        </div>
    );

}

export default PeopleSelectWithGroups;

